const vhUnit = () => {
	document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01 / 16}rem`);
};

export default vhUnit;
